import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DnBtnSize } from '../../dn-primary-btn/dn-primary-btn.config';
import { EmptyPixel } from '../../../constants/emptyPixel';

@Component({
  selector: 'dn-button-base',
  template: '',
  standalone: true,
})
export class DnButtonBaseComponent {
  @Input() text = '';
  @Input() size: DnBtnSize = DnBtnSize.LARGE;
  @Input() rippleEffect: boolean;
  @Output() clickButton = new EventEmitter();
  @Input() backgroundColor: string;
  @Input() isLazy = false;
  @Input() disabled = false;
  @Input() loading = false;

  emptyPixel = EmptyPixel;

  onClick(event: any): void {
    if (this.disabled || this.loading) {
      return;
    }
    this.clickButton.emit(event);
  }
}
